import Axios from 'axios';
import isNull from 'lodash/isNull';

const loadSoundcastEpisodesMaxIndex = soundcastId => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = `/api/soundcast/${soundcastId}/episodes_max_index`;
      const { status, data } = await Axios.get(url);

      if (status === 200) {
        const { maxIndex = null } = data || {};
        resolve( isNull(maxIndex) ? 0 : maxIndex );
      } else {
        throw new Error(`Unable to retrieve ${soundcastId} max index unknown status ${status}`);
      }
    } catch (err) {
      reject(err);
    }
  });
};

export {
  loadSoundcastEpisodesMaxIndex,
};
